export default __webpack_public_path__ + "static/media/ELECTRON_card.18c22bba.svg";